// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__243JC"};